import React from 'react';
import PrivacySettings from '../components/PrivacySettings';

const Privacy: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        
        <div className="prose max-w-none mb-12">
          <h2>Introduction</h2>
          <p>
            At Medical Media, we respect your privacy and are committed to protecting your personal data. 
            This privacy policy will inform you about how we look after your personal data when you visit 
            our website and tell you about your privacy rights and how the law protects you.
          </p>
          
          <h2>The Data We Collect</h2>
          <p>
            We may collect, use, store and transfer different kinds of personal data about you which we 
            have grouped together as follows:
          </p>
          <ul>
            <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
            <li><strong>Contact Data</strong> includes email address, telephone numbers, and physical address.</li>
            <li><strong>Technical Data</strong> includes internet protocol (IP) address, browser type and version, 
            time zone setting and location, browser plug-in types and versions, operating system and platform, 
            and other technology on the devices you use to access this website.</li>
            <li><strong>Usage Data</strong> includes information about how you use our website and services.</li>
            <li><strong>Marketing Data</strong> includes your preferences in receiving marketing from us.</li>
          </ul>
          
          <h2>How We Use Your Data</h2>
          <p>
            We will only use your personal data when the law allows us to. Most commonly, we will use your 
            personal data in the following circumstances:
          </p>
          <ul>
            <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
            <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests 
            and fundamental rights do not override those interests.</li>
            <li>Where we need to comply with a legal obligation.</li>
          </ul>
          
          <h2>Cookies</h2>
          <p>
            Our website uses cookies to distinguish you from other users of our website. This helps us to 
            provide you with a good experience when you browse our website and also allows us to improve our site.
          </p>
          <p>
            You can set your browser to refuse all or some browser cookies, or to alert you when websites set 
            or access cookies. If you disable or refuse cookies, please note that some parts of this website 
            may become inaccessible or not function properly.
          </p>
        </div>
        
        <PrivacySettings />
      </div>
    </div>
  );
};

export default Privacy;